exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-file-thumbnail{max-width:100px}", ""]);

// exports
